export default __webpack_public_path__ + "090622b0dd2f8c5e5540386c34bab8b2.png";